import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'

import { Utente } from '../_models/utente';
import { delayedRetry } from './delayed-retry';

class EnableAuthDueFattori {
  pwdCorrente: string;
  numTelefono: string;
}

class ConfirmAuthDueFattori {
  valToken: string;
}

class DisableAuthDueFattoriBean {
  pwdCorrente: string;
}

@Injectable()
export class UtenteService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "UtenteService";
  }

  /** GET utenti istanza from the server */
  getElencoUtenti(): Observable<Utente[]> {
    let url = `${ServicesConstants.URL_UTENTI}`;

    return this.http.get<Utente[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Utenti`)),
      catchError(this.handleError<Utente[]>(`getElencoUtenti`))
    );
  }

  /** GET utenti istanza from the server */
  getElencoUtentiByName(nomeUtente: string): Observable<Utente[]> {
    let url = `${ServicesConstants.URL_UTENTI}?nomeUtente=${nomeUtente}`;

    return this.http.get<Utente[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Utenti nomeUtente=${nomeUtente}`)),
      catchError(this.handleError<Utente[]>(`getElencoUtentiByName`))
    );
  }

  /** GET Utente by id. Will 404 if id not found */
  getUtente(id: number): Observable<Utente> {
    const url = `${ServicesConstants.URL_UTENTI}/${id}`;
    return this.http.get<Utente>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Utente id=${id}`)),
      catchError(this.handleError<Utente>(`getUtente id=${id}`))
    );
  }

  /** DELETE: is deletable the Utente from the server */
  isUtenteDeletable(utente: Utente | number): Observable<boolean> {
    const id = typeof utente === 'number' ? utente : utente.idUtente;
    const url = `${ServicesConstants.URL_UTENTI}/${id}?cmd=checkCancellabile`;

    return this.http.get<boolean>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`Deletable Utente id=${id}: ${_}`)),
      catchError(this.handleError<boolean>(`isUtenteDeletable id=${id}`))
    );
  }

  //////// Save methods //////////

  /** POST: add a new Utente to the server */
  addUtente(utente: Utente): Observable<Utente> {
    return this.http.post<Utente>(ServicesConstants.URL_UTENTI, utente, this.httpOptions).pipe(
      tap((utente: Utente) => this.log(`added Utente w/ id=${utente.idUtente}`)),
      catchError(this.handleError<Utente>('addUtente'))
    );
  }

  /** DELETE: delete the Utente from the server */
  deleteUtente(utente: Utente | number): Observable<Utente> {
    const id = typeof utente === 'number' ? utente : utente.idUtente;
    const url = `${ServicesConstants.URL_UTENTI}/${id}`;

    return this.http.delete<Utente>(url, this.httpOptions).pipe(
      tap(_ => this.log(`deleted Utente id=${id}`)),
      catchError(this.handleError<Utente>('deleteUtente'))
    );
  }

  /** PUT: update the Utente on the server */
  updateUtente(utente: Utente | number): Observable<any> {
    const id = typeof utente === 'number' ? utente : utente.idUtente;
    const url = `${ServicesConstants.URL_UTENTI}/${id}`;

    return this.http.put(url, utente, this.httpOptions).pipe(
      tap(_ => this.log(`updated Utente id=${id}`)),
      catchError(this.handleError<any>('updateUtente'))
    );
  }

  resetPasswordUtente(utente: Utente): Observable<Utente> {
    const id = typeof utente === 'number' ? utente : utente.idUtente;
    const url = `${ServicesConstants.URL_UTENTI}/${id}?cmd=resetPassword`;

    return this.http.put<Utente>(url, utente, this.httpOptions).pipe(
      tap(_ => this.log(`resetpassword Utente id=${id}`)),
      catchError(this.handleError<Utente>('resetPasswordUtente'))
    );
  }

  richiediCambioPasswordUtente(utente: Utente | number): Observable<any> {
    const id = typeof utente === 'number' ? utente : utente.idUtente;
    const url = `${ServicesConstants.URL_UTENTI}/${id}/?cmd=richiediCambioPassword`;

    return this.http.put(url, utente, this.httpOptions).pipe(
      tap(_ => this.log(`Richiesta CambioPassword Utenteid=${id}`)),
      catchError(this.handleError<any>('richiediCambioPasswordUtente'))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/utente.service.ts